import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import { dismissWorkspaceToast, subscribeWorkspaceToast, type WorkspaceToastItem } from './workspaceToast'

function toneClasses(tone: WorkspaceToastItem['tone']) {
  switch (tone) {
    case 'success':
      return 'border-l-emerald-500 bg-emerald-50 text-emerald-900'
    case 'error':
      return 'border-l-red-500 bg-red-50 text-red-900'
    case 'warning':
      return 'border-l-amber-500 bg-amber-50 text-amber-950'
    default:
      return 'border-l-sky-500 bg-sky-50 text-sky-950'
  }
}

/**
 * 挂载在 document.body，固定视口顶部居中，与旧版伦理台 Toast 位置一致。
 */
export function WorkspaceToastHost() {
  const [items, setItems] = useState<WorkspaceToastItem[]>([])

  useEffect(() => subscribeWorkspaceToast(setItems), [])

  if (typeof document === 'undefined' || items.length === 0) return null

  return createPortal(
    <div
      className="fixed left-1/2 top-4 z-[10050] flex w-[min(100%,28rem)] -translate-x-1/2 flex-col gap-2 px-3 pointer-events-none"
      aria-live="polite"
      aria-relevant="additions removals"
    >
      {items.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto flex items-start gap-2 rounded-lg border border-slate-200/80 py-3 pl-3 pr-2 shadow-lg backdrop-blur-sm border-l-4 ${toneClasses(t.tone)}`}
        >
          <p className="min-w-0 flex-1 text-sm leading-relaxed">{t.text}</p>
          <button
            type="button"
            className="shrink-0 rounded p-1 text-current opacity-60 hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
            aria-label="关闭"
            onClick={() => dismissWorkspaceToast(t.id)}
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>,
    document.body,
  )
}
